
import React, { Component } from "react";
import Chart from "react-apexcharts";

class BarChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      options: {
        chart: {
          id: "basic-bar",  
        },
        plotOptions: {
          bar: {
              horizontal: false,
              columnWidth: '20px', // Controls the width of the bars
              endingShape: 'rounded' // Gives the bars a rounded ending
          }
      },
        colors: ["#02cc9a"],
        xaxis: {
          categories: props?.categories
        },
      },
       series: [
        {
          name: "",
          data: props?.seriesData
        }
      ],
    };
  }

  render() {
    return (
      <div className="app">
        <div className="row">
          <div className="mixed-chart" style={{width:"98%"}}>
            <Chart
              options={this.state.options}
              series={this.state.series}
              type="bar"
              height="260"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default BarChart;

